/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsSlideshowClassic = {
	init: function($section) {

  // Add settings from schema to current object
  window.PXUTheme.jsSlideshowClassic = $.extend(this, window.PXUTheme.getSectionData($section));

  // Selectors
  const $slideshowClassicEl = $section.find('[data-slideshow-classic]').removeClass('is-hidden');

  const flkty = $slideshowClassicEl.flickity({
    wrapAround: true,
    adaptiveHeight: true,
    prevNextButtons: this.number_of_slides > 1 ? this.show_arrows : false,
    pageDots: this.number_of_slides > 1 ? this.show_nav_buttons : false,
    draggable: true,
    imagesLoaded: true,
    fade: this.image_transition == 'fade',
    autoPlay: this.image_slideshow_speed * 1000,
    arrowShape: arrowShape
  }).data('flickity');


  function handleVideo(slide) {

    // Pause every video first
    $slideshowClassicEl.find('video').each(function () {
      this.pause();
      this.currentTime = 0;
    });

    const video = $(slide).find('video').get(0);

    if (!video) {

      flkty.playPlayer();
      return;

    }

    video.play();

    if (video.loop) {

      flkty.playPlayer();

    } else {

      flkty.stopPlayer();

      video.onended = function () {

        flkty.next();
        flkty.playPlayer();

      };

    }

  }


  handleVideo(flkty.selectedElement);

  $slideshowClassicEl.on('change.flickity', function(event, index) {

    handleVideo(flkty.cells[index].element);

  });

  $slideshowClassicEl.on('settle.flickity', function() {

    $slideshowClassicEl.flickity('resize');

  });

},
  blockSelect: function($section, blockId) {
    const $slider = $section.find('[data-image-slideshow]');
    const $sliderIndex = $('#shopify-section-' + blockId).data('slide-index');

    $slider.flickity('select', $sliderIndex, true, true);

  },
	unload: function($section) {

	}
}

/******/ })()
;